// extracted by mini-css-extract-plugin
export default {"container":"Language_container__iik1f","langOption":"Language_langOption__qS-59"};